import type {HttpMethod} from 'openapi-typescript-helpers'
import {HttpError} from '@freckle/student-entities/ts/common/exceptions/http-error'

export type ResponseData<
  Paths extends object,
  Path extends keyof Paths,
  Method extends HttpMethod,
  StatusCode extends number,
  ContentType extends string
> =
  Paths[Path] extends Record<
    Method,
    {responses: Record<StatusCode, {content: Record<ContentType, infer R>}>}
  >
    ? R | undefined
    : never

export type ResponseDatum<
  Paths extends object,
  Path extends keyof Paths,
  Method extends HttpMethod,
  StatusCode extends number,
  ContentType extends string
> =
  // Extract unit type if response is an array
  Paths[Path] extends Record<
    Method,
    {responses: Record<StatusCode, {content: Record<ContentType, Array<infer R>>}>}
  >
    ? R | undefined
    : ResponseData<Paths, Path, Method, StatusCode, ContentType>

export function extractData<T = unknown>({
  response,
  data
}: {
  data?: T
  response: Response
}): T | Promise<never> {
  return response.ok && data !== undefined ? data : Promise.reject(new HttpError(response))
}
